import { Breadcrumb as Breadcrumb$2, Link } from './style.js';
import Icon from '../Icon/Icon.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ICON_UI_CHEVRON_RIGHT } from '../../icons/ICON_UI_CHEVRON_RIGHT.js';

var Breadcrumb = function Breadcrumb(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    _ref$uri = _ref.uri,
    uri = _ref$uri === void 0 ? null : _ref$uri,
    _ref$desktopOnly = _ref.desktopOnly,
    desktopOnly = _ref$desktopOnly === void 0 ? null : _ref$desktopOnly,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? null : _ref$position;
  if (!name || !uri || !position) {
    return false;
  }
  return /*#__PURE__*/jsxs(Breadcrumb$2, {
    itemScope: true,
    itemProp: "itemListElement",
    itemType: "https://schema.org/ListItem"
    // @ts-ignore
    ,
    $desktopOnly: desktopOnly,
    children: [/*#__PURE__*/jsxs(Link, {
      itemProp: "item",
      href: uri,
      target: target
      // @ts-ignore
      ,
      name: name,
      children: [/*#__PURE__*/jsx("span", {
        itemProp: "name",
        children: name
      }), /*#__PURE__*/jsx("meta", {
        itemProp: "position",
        content: position
      })]
    }), /*#__PURE__*/jsx(Icon, {
      path: ICON_UI_CHEVRON_RIGHT,
      className: "uikit-breadcrumbs__arrow-icon",
      size: "xxs"
    })]
  });
};
var Breadcrumb$1 = Breadcrumb;

export { Breadcrumb$1 as default };
//# sourceMappingURL=Breadcrumb.js.map
